// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"024033ab","222":"9ada692e","406":"0600986f","767":"650738d4","812":"e1fcd366","873":"de2c0ef3","920":"76e3c19e"}[chunkId] + ".chunk.js";
};